import React from "react";

import { useTheme, withThemeProvider } from "@narvar/nth-hook-theme";
import { Language } from "../";
import { LineItemsGroupProps } from "./types";

const LineItemsGroupC: React.FC<LineItemsGroupProps> = ({
  selectedGroup,
  itemsWereSelected,
  children,
}) => {
  const { bodytextDefaultNone } = useTheme();

  return (
    <>
      {!selectedGroup && itemsWereSelected && (
        <div
          style={{
            ...bodytextDefaultNone,
            margin: "1.5rem auto 1rem auto",
          }}>
          <Language langKey="returnsLineItemGroupIneligibleDescription" />
        </div>
      )}
      {children}
    </>
  );
};

export const LineItemsGroup = withThemeProvider(LineItemsGroupC, {
  themeTokens: ["bodytextDefaultNone"],
});
